import { useState } from "react";
import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";

export function DateField({ value, onChange, placeholder = "Pick a date", testId, className = "w-44" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className={`${className} justify-start rounded-sm font-normal`} data-testid={testId}>
          <CalendarIcon className="h-4 w-4 mr-2 text-muted-foreground" />
          {value ? format(value, "PPP") : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={value} onSelect={(d) => { onChange(d || undefined); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
